<template>
  <div>
    <b-modal ref="progressBarModalRef" centered size="l" no-close-on-backdrop>
      <template #modal-header>
        <h5>Downloadstatus</h5>
      </template>
      <template>
        <p class="my-4 paragraph-to-style" v-if="(((counter / selectedConfigIds.length) * 100) < 100)">Download läuft
        </p>
        <b-alert class="success-alert" v-else variant="success" show> Der Download wurde erfolgreich
          abgeschlossen. <fa-icon :icon="['fas', 'thumbs-up']" fixed-width class="mr-2" /></b-alert>

        <b-progress height="20px" :value="(counter / selectedConfigIds.length) * 100" variant="success" show-progress
          striped :animated="animate"></b-progress>
      </template>
      <template #modal-footer>
        <button class="btn btn-primary" @click="resetVariable()">
          Ok
        </button>
      </template>
    </b-modal>

    <b-modal ref="unsuccessfulDownloadModalRef" centered size="l" no-close-on-backdrop>
      <template #modal-header>
        <h5>Downloadstatus
        </h5>
      </template>
      <template>
        <b-alert show class="danger-alert" variant="danger">
          <div class="warring-img-container">
            <img src="../img/exclamation-triangle.svg" alt="Warring image">
          </div>
          Der Download war leider nicht
          erfolgreich. Bitte versuchen Sie es erneut.
          <p class="paragraph-to-style">
            {{ error }}
          </p>
        </b-alert>
      </template>
      <template #modal-footer>
        <button class="btn btn-primary" @click="closeUnsuccessError()">
          Ok
        </button>
      </template>
    </b-modal>
    <div class="show-error" v-if="showError">
      <p class="error-text">Geräteauswahl erforderlich!</p>
    </div>
    <b-list-group>
      <b-list-group-item class="config-list-element">
        <b-form-checkbox v-model="selectAll" name="check-button" size="lg" @change="toggleAll" switch>
          <p class="paragraph-to-style" v-if="selectAll">Alle Geräte abwählen</p>
          <p class="paragraph-to-style" v-else>Alle verfügbaren Geräte auswählen</p>
        </b-form-checkbox>
      </b-list-group-item>
      <b-list-group-item class="config-list-element" v-for="(device, index) in devices" v-bind:key="'device-' + index"
        v-on:click="hideError()">
        <b-form-checkbox v-model="selectedConfigIds" :value="device.id" name="check-button" size="lg" switch>
          {{ device.name }}
        </b-form-checkbox>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { httpsCallable } from "firebase/functions"
import { functions } from "../plugins/firebase"
import Papa from 'papaparse';
export default {
  name: 'ComponentOverviewExport',
  components: {
  },
  props: {
    configurationsData: Array,
    deviceMainName: String,
  },
  data() {
    return {
      devices: [],
      selectedConfigIds: [],
      selectAll: false,
      animate: true,
      counter: 0,
      showError: false,
      showGenerateFileContainer: true,
      error: "",
    }
  },

  mounted() {
    this.getDeviceName()
  },

  methods: {
    closeUnsuccessError() {
      this.counter = 0;
      this.$refs.unsuccessfulDownloadModalRef.hide();
    },

    resetVariable() {
      this.counter = 0;
      this.$refs.progressBarModalRef.hide();
      this.$refs.unsuccessfulDownloadModalRef.hide();
      this.$emit('hideTheFirstModal');
    },
    hideError() {
      this.showError = false;
    },

    toggleAll(checked) {
      this.selectedConfigIds = checked ? this.devices.map(device => device.id) : [];
      this.showError = false;
    },
    //Offer a list of device names for user choice.
    getDeviceName() {
      this.configurationsData.forEach(element => {
        if (element.data.name !== 'Platzhalter') {
          this.devices.push({
            id: element.id,
            name: element.data.name,
          }
          )
        }
      });
    },

    // Execute the download and generate an Excel file link for all selected devices.
    async generateExclFile() {
      if (this.selectedConfigIds.length > 0) {
        this.$refs.progressBarModalRef.show()
        let allData = [];
        try {
          const generateComponentsFile = httpsCallable(functions, 'generateConfigFiles')
          const singleFilePromise = this.selectedConfigIds.map(async (configId) => {
            return await generateComponentsFile({ configurationId: configId })
              .then(result => {
                const count = this.counter;
                this.counter = count + 1;
                return result.data
              })
          });
          const responses = await Promise.all(singleFilePromise);
          responses.forEach(response => {
            allData = allData.concat(response)
          })

        } catch (error) {
          console.error("Fehler beim generieren der Dateien: ", error);
          this.error = error;
          this.$refs.progressBarModalRef.hide();
          this.$refs.unsuccessfulDownloadModalRef.show();
        } finally {
          if (allData.length > 0) {
            const text = Papa.unparse(allData);
            const filename = 'Config-' + this.deviceMainName.replace('"', "").replaceAll(" ", "_") + ".csv";
            this.download(filename, text);
          }
        }
      } else {
        this.showGenerateFileContainer = false;
        this.showError = true;
      }
    },
    // Generates a download link and programmatically initiates the file download in the browser.
    download(filename, text) {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);

      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },

  },
}
</script>

<style>
.config-list-element {
  width: 100%;
  border-radius: 4px;
  padding: 1rem !important;
}

.config-list-element:hover {
  color: #16181b;
  text-decoration: none;
  background-color: #e9ecef;
  box-shadow: rgba(7, 10, 7, 0.45) 0px 0.5px 4px;
}

.config-list-element .custom-control-label {
  width: 100%;
  display: block !important;
}

.paragraph-to-style {
  margin: 0 0 0 0.5rem;
  font-weight: 700;
  font-size: large;
  width: 100%;
}

.btn-container {
  width: 100%;
  text-align: right;
  margin: 0 2rem 1rem 0;
}

.btn-container-error {
  width: 100%;
  text-align: center;
  padding: 2rem 0 1rem 0;
  border-top: solid 1px;
}

.progress {
  margin: 2rem 0 2rem 0;
}

.show-error {
  width: 100%;
  text-align: center;
}

.show-error>p {
  font-size: medium;
  font-weight: 500;
  color: rgb(231, 16, 16);
}

.danger-alert {
  margin: 0;
}

.danger-alert>p {
  width: 100%;
  text-align: center;
}

.success-alert {
  margin: 1rem 0 3rem 0;
}

.warring-img-container {
  width: 100%;
  height: 180px;
  display: flex;
  justify-content: center;
  padding: 1rem 0 2rem 0;
}

.warring-img-container>img {
  animation-name: beat;
  animation-duration: 0.70s;
  animation-iteration-count: infinite;
}

@keyframes beat {
  0% {
    width: 29%;
  }

  100% {
    width: 30%;
  }
}
</style>
